import React from "react";
import { Box, Text, Heading } from "@chakra-ui/react";

const Home = () => {
  return (
    <Box
      bg="#005770"
      color="white"
      minH="60vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      px={{ base: 4, md: 8 }}
      textAlign="center"
    >
      <Box maxW={{ base: "90%", md: "800px" }}>
        <Text fontSize={{ base: "lg", md: "xl" }} fontWeight="medium" mb={2} className="fade-in-up">
          Our services
        </Text>
        <Heading
          fontSize={{ base: "2xl", md: "4xl" }}
          fontWeight="bold"
          mb={{ base: 3, md: 6 }}
          className="fade-in-up"
        >
          Digital Growth with Indian Jugaad!
        </Heading>
        <Text fontSize={{ base: "md", md: "lg" }} color="gray.300">
          <Text as="span" color="orange.200" fontWeight="semibold" className="fade-in-up">
            Creative
          </Text>{" "}
          strategies,{" "}
          <Text as="span" color="orange.200" fontWeight="semibold" className="fade-in-up">
            smart
          </Text>{" "}
          execution, and a touch of{" "}
          <Text as="span" color="orange.200" fontWeight="semibold" className="fade-in-up">
            Marwadi jugaad
          </Text>{" "}
          — because great design isn’t just about looks,{" "}
          <Text as="span" color="orange.200" fontStyle="italic" className="fade-in-up">
            it’s about results.
          </Text>
        </Text>
      </Box>
    </Box>
  );
};

export default Home;
